import { render, staticRenderFns } from "./WaktuNormal.vue?vue&type=template&id=009860da&"
import script from "./WaktuNormal.vue?vue&type=script&lang=js&"
export * from "./WaktuNormal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports